export const getInitialLoadProps = () => {
    return {
        bannerName: 'banner_name',
        bannerAction: {
            key: 'banner_action',
            fn: () => 'initial_load'
        },
        bannerId: 'banner_id',
        bannerType: 'banner_type',
        eventCategory: 'event_category'
    };
};
